var root=require("./_root"),Symbol=root.Symbol;module.exports=Symbol;